import { useEffect } from 'react';
import type { SocialProviderConfig } from '../../constants/socialProviders';

function generateRandomString(bytes = 32) {
  const array = new Uint8Array(bytes);
  window.crypto.getRandomValues(array);
  const base64 = btoa(String.fromCharCode.apply(null, Array.from(array)));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

const AppleSocialLogin = ({ providerConfig }: { providerConfig: SocialProviderConfig }) => {
  useEffect(() => {
    const state = generateRandomString(16);
    sessionStorage.setItem('apple_oauth_state', state);

    const params = new URLSearchParams({
      client_id: providerConfig.clientId ?? '',
      redirect_uri: providerConfig.callbackUrl ?? '',
      response_type: 'code',
      response_mode: 'query',
      state,
    });

    window.location.href = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
  }, [providerConfig.callbackUrl, providerConfig.clientId]);

  return (
    <div
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        background: '#ffffff',
        color: '#333',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderTop: '4px solid #000000',
            borderRadius: '50%',
            width: 50,
            height: 50,
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px',
          }}
        />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AppleSocialLogin;